module.exports = __webpack_public_path__ + "img/1440.74bbc950.jpg";